import React from 'react';

const CameraIcon = () => (
  <svg width="28" height="27" viewBox="0 0 28 27" fill="none" xmlns="http://www.w3.org/2000/svg">
    <ellipse cx="13.6935" cy="13.625" rx="13.5" ry="13" fill="#F7F7F9" />
    <path
      d="M13.6936 11.0977C12.2045 11.0977 10.9936 12.2854 10.9936 13.7458C10.9936 15.2069 12.2045 16.394 13.6936 16.394C15.1826 16.394 16.3936 15.2069 16.3936 13.7458C16.3936 12.286 15.1826 11.0977 13.6936 11.0977Z"
      fill="#757575"
    />
    <path
      d="M19.0935 9.11177H17.7907C17.3398 9.11177 16.918 8.89065 16.6675 8.52256L16.1194 7.71488C15.869 7.34678 15.4471 7.125 14.9962 7.125H12.3907C11.9398 7.125 11.518 7.34678 11.2675 7.71421L10.7194 8.5219C10.469 8.89065 10.0471 9.11111 9.59623 9.11111H8.29348C7.54761 9.11111 6.94348 9.7043 6.94348 10.4352V17.7176C6.94348 18.4485 7.54761 19.0417 8.29348 19.0417H19.0935C19.8387 19.0417 20.4435 18.4485 20.4435 17.7176V10.4352C20.4435 9.70496 19.8387 9.11177 19.0935 9.11177ZM13.6935 17.7176C11.4599 17.7176 9.64348 15.9361 9.64348 13.7454C9.64348 11.5554 11.4599 9.77315 13.6935 9.77315C15.9271 9.77315 17.7435 11.5554 17.7435 13.7454C17.7435 15.9367 15.9271 17.7176 13.6935 17.7176Z"
      fill="#757575"
    />
  </svg>
);

export default CameraIcon;
